<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      门店管理
      <small>/&nbsp;门店列表</small>
    </h1>

    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->

        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">门店列表</h4>
              </div>
              <!-- end panel-heading -->
              <!-- begin panel-body -->
              <div class="panel-body">
                <form style="margin-top:16px;padding-left:15px;">
                  <fieldset>
                    <div class="form-group row m-b-15">
                      <label class="col-md-1 col-form-label">服务商信息</label>
                      <div class="col-md-2">
                        <input
                          v-if="recom_id"
                          type="text"
                          class="form-control"
                          placeholder="服务商编码/服务商名称"
                          :disabled="true"
                          v-model="recomName"
                        >
                        <input
                          v-else
                          type="text"
                          class="form-control"
                          placeholder="服务商编码/服务商名称"
                          v-model="recomFuzzy"
                        >
                      </div>
                      <label class="col-md-1 col-form-label">门店名称</label>
                      <div class="col-md-2">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="门店名称"
                          v-model="shopFuzzy"
                        >
                      </div>
                      <label class="col-md-1 col-form-label">联系方式</label>
                      <div class="col-md-2">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="联系方式"
                          v-model="shopTel"
                        >
                      </div>
                      <div class="col-md-3"></div>
                      <label class="col-md-1 col-form-label LineSpacing">地址</label>
                      <div class="col-md-2 LineSpacing">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="地址"
                          v-model="addRess"
                        >
                      </div>
                      <label class="col-md-1 col-form-label LineSpacing">租户</label>
                      <div class="col-md-2 LineSpacing">
                        <el-select
                          v-model="form.lesseeId"
                          style="width:100%"
                          clearable
                          filterable
                          placeholder="请选择"
                          @change="(val) => {
                            $set(form, 'deptId', undefined)
                            $set(form, 'firstAreaId', undefined)
                            $set(form, 'secondAreaId', undefined)
                            $set(form, 'thirdAreaId', undefined)
                              departmentList = []
                              regionalList = []
                               partitionList = []
                               districtList = []
                              if (val) {
                                getDeptList()
                                getAreaPageList()
                              }
                            }"
                        >
                          <el-option
                            v-for="item in lesseeList"
                            :key="item.id"
                            :label="item.lesseeName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                      <label class="col-md-1 col-form-label LineSpacing">部门</label>
                      <div class="col-md-2 LineSpacing">
                        <el-select
                          v-model="form.deptId"
                          style="width:100%"
                          clearable
                          filterable
                          placeholder="请选择"
                          @change="(val) => {
                            $set(form, 'firstAreaId', undefined)
                            $set(form, 'secondAreaId', undefined)
                            $set(form, 'thirdAreaId', undefined)
                              regionalList = []
                               partitionList = []
                               districtList = []
                              getAreaPageList()
                            }"
                        >
                          <el-option
                            v-for="item in departmentList"
                            :key="item.id"
                            :label="item.deptName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                      <div class="col-md-3 LineSpacing"></div>
                      <label class="col-md-1 col-form-label LineSpacing">大区</label>
                      <div class="col-md-2 LineSpacing">
                        <el-select
                          v-model="form.firstAreaId"
                          style="width:100%"
                          clearable
                          filterable
                          placeholder="请选择"
                          @change="(val) => {
                               $set(form, 'secondAreaId', undefined)
                            $set(form, 'thirdAreaId', undefined)
                               partitionList = []
                               districtList = []
                              if (val) {
                                getAreaPageList()
                              }
                            }"
                        >
                          <el-option
                            v-for="item in regionalList"
                            :key="item.id"
                            :label="item.areaName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                      <label class="col-md-1 col-form-label LineSpacing">分区</label>
                      <div class="col-md-2 LineSpacing">
                        <el-select
                          v-model="form.secondAreaId"
                          style="width:100%"
                          clearable
                          filterable
                          placeholder="请选择"
                          @change="(val) => {
                              $set(form, 'thirdAreaId', undefined)
                               districtList = []
                              if (val) {
                                getAreaPageList()
                              }
                            }"
                        >
                          <el-option
                            v-for="item in partitionList"
                            :key="item.id"
                            :label="item.areaName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                      <label class="col-md-1 col-form-label LineSpacing">区域</label>
                      <div class="col-md-2 LineSpacing">
                        <el-select
                          v-model="form.thirdAreaId"
                          style="width:100%"
                          clearable
                          filterable
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="item in districtList"
                            :key="item.id"
                            :label="item.areaName"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </div>
                      <div class="col-md-3 LineSpacing"></div>
                      <label class="col-md-1 col-form-label LineSpacing">状态</label>
                      <div class="col-md-2 LineSpacing">
                        <el-select
                          v-model="status"
                          style="width:100%"
                          clearable
                          filterable
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </div>
                      <label class="col-md-1 col-form-label LineSpacing">创建时间</label>
                      <div class="col-md-3 LineSpacing">
                        <el-date-picker
                          style="width: 100%;"
                          v-model="value1"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
                        </el-date-picker>
                      </div>
                      <div class="col-md-1 LineSpacing">
                        <a
                          class="btn btn-primary ButtonColor m-r-5"
                          @click="SearchClick()"
                        >查询</a>
                      </div>
                      <div class="col-md-4"></div>
                    </div>
                  </fieldset>
                </form>
                <div style="text-align:right;margin-bottom:20px;" v-if="recom_id">
                  <button @click="handleLoadBatchShopGoods(0)" :disabled="!selection.length"
                          class="btn btn-success ButtonColor">批量上架
                  </button>
                  <button @click="handleLoadBatchShopGoods(1)" :disabled="!selection.length"
                          class="btn btn-warning ButtonColor">批量下架
                  </button>
                  <button @click="handleUploadBg" :disabled="!selection.length" class="btn btn-danger ButtonColor">
                    批量设置背景图
                  </button>
                  <a
                    class="btn btn-primary ButtonColor"
                    @click="ExportClick()"
                  >导出</a>
                  <a
                    class="btn btn-primary ButtonColor"
                    @click="AddClick()"
                  >新增</a>
                </div>
                <div style="text-align:right;margin-bottom:20px;" v-else>
                  <a
                    class="btn btn-primary ButtonColor"
                    @click="ExportClick()"
                  >导出</a>
                </div>
                <el-table
                  border
                  :data="UserManagementList"
                  @selection-change="(val) => selection = val"
                  style="width: 100%"
                >
                  <el-table-column type="selection" v-if="recom_id"/>
                  <el-table-column prop="ordernumber" label="序号" width="60" align="center"
                                   show-overflow-tooltip></el-table-column>
                  <el-table-column prop="recomName" label="服务商名称" width="250" align="center"
                                   show-overflow-tooltip></el-table-column>
                  <el-table-column prop="shopName" label="门店名称" width="250" align="center"
                                   show-overflow-tooltip></el-table-column>
                  <el-table-column label="门店地址" width="250" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{ scope.row.province }}{{ scope.row.city }}{{ scope.row.district }}{{ scope.row.address }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="是否切换小程序" width="120" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.toggleMark === 1 ? '是' : '否'}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="状态" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                      {{scope.row.status === 0 ? '已禁用' : '启用中'}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="bossName" label="老板" align="center" width="150"
                                   show-overflow-tooltip></el-table-column>
                  <el-table-column prop="shoperTel" label="联系方式" align="center" width="150"
                                   show-overflow-tooltip></el-table-column>
                  <el-table-column prop="inputTime" label="创建时间" width="160" align="center"
                                   show-overflow-tooltip></el-table-column>
                  <el-table-column label="备注" prop="noted" align="center" show-overflow-tooltip/>
                  <el-table-column label="店员数量" width="120" align="center" show-overflow-tooltip fixed="right">
                    <template slot-scope="scope">
                      <span>{{ scope.row.shoperCount }}</span>
                      <el-button type="text" @click="SettingClick(scope.row)">
                        [查看设置]
                      </el-button>
                    </template>
                  </el-table-column>
                  <el-table-column label="设置" width="120" align="center" fixed="right">
                    <template slot-scope="scope">
                      <el-button type="text" @click="SettingShop(scope.row)">门店管理</el-button>
                    </template>
                  </el-table-column>
                  <el-table-column label="门店二维码" width="120" align="center" fixed="right">
                    <template slot-scope="scope">
                      <a class="btn btn-primary btn-sm ButtonColor" @click="CodeClick(scope.row)">生成二维码</a>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="200" align="center" fixed="right">
                    <template slot-scope="scope">
                      <a
                        class="btn btn-primary btn-sm ButtonColor"

                        @click="DetailClick(scope.row)"
                      >详情</a>
                      <a
                        v-if='!isRecomRole'
                        class="btn btn-primary btn-sm ButtonColor"

                        @click="EditClick(scope.row)"
                      >编辑</a>
                      <a
                        v-if="hiddenbutton != 6533"
                        class="btn btn-warning btn-sm ButtonColor"
                        @click="DeleteClick(scope.row, scope.row.status === 0 ? '启用' : '禁用')"
                      >{{scope.row.status === 0 ? '启用' : '禁用'}}</a>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="PaginationStyle">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageindex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    background
                    :total="totalCount"
                  ></el-pagination>
                </div>
                <div style="height:46px;padding-top:46px;" v-if="recom_id">
                  <a class="btn btn-primary m-r-5" style="float:right;cursor:pointer;color:#fff !important"
                     @click="Goback">返&nbsp;&nbsp;回</a>
                  <span class="clear"></span>
                </div>
              </div>

              <!-- end panel-body -->
            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->
        </div>

        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
    <el-dialog title :visible.sync="outerVisibles" width="600px" :before-close="handleCloseCanvas">
      <div
        class="ModelPaddings"
        v-loading="imgLoading"
        element-loading-text="加载中"
      >
        <img :src="imgurl" alt="" >
      </div>
      <div class="ButtonSty">
        <el-button type="primary" :loading="signLoading" @click="downLoadShopSign">下载展示牌</el-button>
        <el-button @click="downLoadQrCode(imgurl, shopName)">下载二维码</el-button>
      </div>
    </el-dialog>
    <el-dialog title :visible.sync="outerVisible" :width="OuterWidth" :before-close="handleClose">
      <div v-if="EditDialog === 2" class="ModelPadding">
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">您确定{{statusName}}吗?</div>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button class="swal-button swal-button--confirm btn btn-primary" @click="MakeSure" :disabled="disabled">确定
            </button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消
            </div>
          </div>
        </div>
      </div>
      <div v-if="EditDialog === 1" class="ModelPadding">
        <div class="swal-title" style="margin-top:0px">{{ DialogTitle }}</div>
        <el-form
          :inline="true"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="150px"
          class="demo-form-inline"
        >
          <el-form-item v-if="recomRegionalList.length > 1" label="大区:" prop="firstAreaId">
            <el-select
              v-model="ruleForm.firstAreaId"
              class="DistributorMargin InputWidth"
              clearable
              filterable
              placeholder="请选择"
              @change="(val) => {
                $set(ruleForm, 'secondAreaId', undefined)
                $set(ruleForm, 'thirdAreaId', undefined)
                recomPartitionList = []
                recomDistrictList = []
                if (val) {
                  getRecomAreaPageList()
                }
              }"
            >
              <el-option
                v-for="item in recomRegionalList"
                :key="item.areaId"
                :disabled="!item.status"
                :label="item.areaName"
                :value="item.areaId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分区:" v-if="recomPartitionList.length > 0" prop="secondAreaId">
            <el-select
              v-model="ruleForm.secondAreaId"
              class="DistributorMargin InputWidth"
              clearable
              filterable
              placeholder="请选择"
              @change="(val) => {
                $set(ruleForm, 'thirdAreaId', undefined)
                recomDistrictList = []
                if (val) {
                  getRecomAreaPageList()
                }
              }"
            >
              <el-option
                v-for="item in recomPartitionList"
                :key="item.id"
                :label="item.areaName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区域:" v-if="recomDistrictList.length > 0"   prop="thirdAreaId">
            <el-select
              v-model="ruleForm.thirdAreaId"
              class="DistributorMargin InputWidth"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in recomDistrictList"
                :key="item.id"
                :label="item.areaName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item  prop="thirdShopCode">
            <span slot="label">店铺编码
               <el-tooltip class="item" effect="light" content="与租户进行数据对接时使用，非必要时无需填写" placement="top-start">
                  <i class="el-icon-question"></i>
                </el-tooltip>
              :</span>
            <el-input v-model="ruleForm.thirdShopCode" :maxlength="30" placeholder="店铺编码" class="DistributorMargin InputWidth"></el-input>
          </el-form-item>
          <el-form-item label="门店编号:" prop="shopCode">
            <el-input v-model="ruleForm.shopCode" placeholder="门店编号" class="DistributorMargin InputWidth"></el-input>
          </el-form-item>
          <el-form-item label="门店名称:" prop="shopName">
            <el-input v-model="ruleForm.shopName" placeholder="门店名称" class="DistributorMargin InputWidth"></el-input>
          </el-form-item>
          <el-form-item label="客户端分润方式:" prop="transferCode">
            <el-select v-model="ruleForm.transferCode" clearable placeholder="请选择" style="width:202px"
                       class="DistributorMargin" @change="courierMarkChange">
              <el-option
                v-for="item in transferList"
                :key="item.transferCode"
                :label="item.transferName"
                :value="String(item.transferCode)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="店长端分润方式:" prop="managerTransferCode">
            <el-select v-model="ruleForm.managerTransferCode" clearable placeholder="请选择" style="width:202px"
                       class="DistributorMargin" @change="courierMarkChange">
              <el-option
                v-for="item in transferList"
                :key="item.transferCode"
                :label="item.transferName"
                :value="String(item.transferCode)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="取货方式:" prop="courierMark">
            <el-select v-model="ruleForm.courierMark" clearable placeholder="请选择" style="width:202px"
                       class="DistributorMargin">
              <el-option
                v-for="item in courierMarkList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="老板姓名:" prop="bossName">
            <el-input v-model="ruleForm.bossName" placeholder="老板姓名" class="DistributorMargin InputWidth"></el-input>
          </el-form-item>
          <el-form-item label="联系方式:" prop="shopTel">
            <el-input v-model="ruleForm.shopTel" placeholder="联系方式" class="DistributorMargin InputWidth"></el-input>
          </el-form-item>
          <el-form-item label="所在省:" prop="province" class="labelstyle">
            <el-select
              v-model="ruleForm.province"
              clearable
              filterable
              placeholder="请选择"
              class="DistributorMargin InputWidth"
              @change="provinceChange"
            >
              <el-option
                v-for="item in ProvincesList"
                :key="item.provinceId"
                :label="item.provinceName"
                :value="item.provinceName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在市:" prop="city" class="labelstyle">
            <el-select
              v-model="ruleForm.city"
              clearable
              filterable
              placeholder="请选择"
              class="DistributorMargin InputWidth"
              @change="CityChange"
            >
              <el-option
                v-for="item in cityList"
                :key="item.cityId"
                :label="item.cityName"
                :value="item.cityName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="所在区:"
            prop="district"
            class="labelstyle"
          >
            <el-select
              v-model="ruleForm.district"
              clearable
              filterable
              placeholder="请选择"
              class="DistributorMargin InputWidth"
            >
              <el-option
                v-for="item in countryList"
                :key="item.countyId"
                :label="item.countyName"
                :value="item.countyName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="详细地址:" prop="address">
            <el-input v-model="ruleForm.address" placeholder="详细地址" class="DistributorMargin InputWidth"></el-input>
          </el-form-item>
          <el-form-item label="账户类型:" prop="bankType">
            <el-select v-model="ruleForm.bankType" clearable placeholder="请选择" style="width:202px"
                       class="DistributorMargin">
              <el-option
                v-for="item in bankoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="账户名称:" prop="trueName">
            <el-input v-model="ruleForm.trueName" placeholder="账户名称" class="DistributorMargin InputWidth"></el-input>
          </el-form-item>
          <el-form-item label="银行卡号:" prop="bankCard">
            <el-input v-model="ruleForm.bankCard" placeholder="银行卡号" class="DistributorMargin InputWidth"></el-input>
          </el-form-item>
          <el-form-item label="开户银行:" prop="bankName">
            <el-select
              filterable
              clearable
              v-model="ruleForm.bankName"
              placeholder="请选择"
              class="DistributorMargin InputWidth"
            >
              <el-option
                v-for="item in bankList"
                :key="item.id"
                :label="item.bankName"
                :value="item.bankCode"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="银行所属省:" prop="bankProvince">
            <el-select v-model="ruleForm.bankProvince" clearable filterable placeholder="请选择" style="width:202px"
                       class="DistributorMargin" @change="bankChange">
              <el-option
                v-for="item in ProvincesLists"
                :key="item.provinceId"
                :label="item.provinceName"
                :value="item.provinceName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="银行所属市:" prop="bankCity">
            <el-select v-model="ruleForm.bankCity" clearable filterable placeholder="请选择" style="width:202px"
                       class="DistributorMargin">
              <el-option
                v-for="item in cityLists"
                :key="item.cityId"
                :label="item.cityName"
                :value="item.cityName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开户支行:" prop="bankBranchName">
            <el-input v-model="ruleForm.bankBranchName" placeholder="开户行"
                      class="DistributorMargin InputWidth"></el-input>
          </el-form-item>

          <el-form-item v-if="ruleForm.bankType === 'P'" label="持卡人身份证号:" prop="idCard">
            <el-input v-model="ruleForm.idCard" placeholder="持卡人身份证号" class="DistributorMargin InputWidth"></el-input>
          </el-form-item>
          <el-form-item v-if="ruleForm.bankType === 'C'" label="统一社会信用代码:" prop="creditCode"
                        class="labelstyle">
            <el-input v-model="ruleForm.creditCode"
                      placeholder="统一社会信用代码"
                      :maxLength="18"
                      @change="(val) => {
                        ruleForm.creditCode = val.toUpperCase()
                      }"
                      class="DistributorMargin InputWidth"></el-input>
          </el-form-item>
          <el-form-item label="持卡人手机号:" prop="bankTel">
            <el-input v-model="ruleForm.bankTel" placeholder="持卡人手机号" class="DistributorMargin InputWidth"></el-input>
            <p style="padding-left: 16px; color: #F56C6C;margin-bottom: 0;">（短信提醒）</p>
          </el-form-item>
          <el-form-item label="推广人:" prop="lesseePersonCode" v-if="ruleForm.lesseeId === 2">
            <el-select
              class="DistributorMargin InputWidth"
              v-model="ruleForm.lesseePersonCode"
              clearable
              filterable
              remote
              placeholder="请选择"
              :remote-method="getPersonPageList"
            >
              <el-option
                v-for="item in personList"
                :key="item.code"
                :label="item.name + ' ' + item.code"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <br>
          <el-form-item label="备注:" prop="noted" :inline="false">
            <el-input
              type="textarea"
              v-model="ruleForm.noted"
              rows="4"
              placeholder="备注"
              class="DistributorMargin"
              style="width: 560px"
            />
          </el-form-item>
          <el-form-item label="秒返短信通知手机号:" prop="telephones" :inline="false">
            <el-input
              type="textarea"
              v-model="ruleForm.telephones"
              rows="4"
              placeholder="请输入手机号"
              class="DistributorMargin"
              style="width: 560px"
            />
            <p style="padding-left: 16px;">(提示：可填写多个手机号，以逗号分隔)</p>
          </el-form-item>
        </el-form>
        <div class="clear"></div>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSureEdit('ruleForm')"
              :disabled="disabled"
            >确定
            </button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      v-if="batchGoodsVisible"
      :title="`批量${['上架', '下架'][batchMode]}`"
      :visible.sync="batchGoodsVisible"
      @close="() => {
        brandId = ''
        seriesId = ''
        fuzzy = ''
      }"
    >
      <form
        style="margin-top:16px;padding-left:15px;"
      >
        <fieldset>
          <div class="form-group row m-b-15">
            <label class="col-md-1 col-form-label">品牌名称</label>
            <div class="col-md-2">
              <v-selectpage
                :data="brandList"
                key-field="brandId"
                show-field="brandName"
                placeholder="品牌名称"
                v-model="brandId"
                title=""
                ref="brand"
              ></v-selectpage>
            </div>

            <label class="col-md-1 col-form-label">系列名称</label>
            <div class="col-md-2">
              <v-selectpage
                :data="seriesList"
                key-field="seriesId"
                show-field="seriesName"
                placeholder="系列名称"
                v-model="seriesId"
                title=""
                ref="series"
              ></v-selectpage>
            </div>

            <label class="col-md-1 col-form-label ">商品名称</label>
            <div class="col-md-2 ">
              <input
                type="text"
                class="form-control"
                placeholder="商品编号/商品名称"
                v-model="fuzzy"
              >
            </div>
            <div class="col-md-2">
              <a class="btn btn-primary ButtonColor m-r-5" style="float:left;"
                 @click="() => handleLoadBatchShopGoods()">查询</a>
            </div>
          </div>
          <div class="form-group row m-b-15"></div>
        </fieldset>
      </form>
      <el-table
        :data="batchGoodsList"
        @selection-change="(val) => (selectionGoods = val)"
        height="600px"
        border
      >
        <el-table-column type="selection"/>
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column prop="goodsCode" label="商品编号" align="center"></el-table-column>
        <el-table-column prop="goodsName" label="商品名称" show-overflow-tooltip header-align="center"></el-table-column>
        <el-table-column prop="packageRates" label="包装率" align="center"></el-table-column>
        <el-table-column prop="groupName" label="分组" align="center"></el-table-column>
        <el-table-column prop="brandName" label="品牌" align="center"></el-table-column>
        <el-table-column prop="seriesName" label="系列" align="center"></el-table-column>
      </el-table>
      <div slot="footer">
        <button v-if="batchMode === 0" :disabled="!selectionGoods.length" class="btn btn-primary ButtonColor"
                @click="handleBatchGoods">上架
        </button>
        <button v-if="batchMode === 1" :disabled="!selectionGoods.length" class="btn btn-primary ButtonColor"
                @click="handleBatchGoods">下架
        </button>
        <button class="btn" @click="batchGoodsVisible = false">取消</button>
      </div>
    </el-dialog>

    <el-dialog v-if="showTips" title="提示" :visible="showTips" @close="() => {
       showTips = false
      }">
      <el-table
        :data="tipsList"
        :span-method="objectSpanMethod"
        border
      >
        <el-table-column prop="shopName" label="门店名称" align="center"></el-table-column>
        <el-table-column prop="goodsName" label="商品名称" align="center"></el-table-column>
        <el-table-column prop="errorMsg" label="失败原因" align="center"></el-table-column>
      </el-table>
      <div slot="footer">
        <button class="btn btn-primary ButtonColor" @click="showTips= false">确定</button>
      </div>
    </el-dialog>
    <el-dialog
      v-if="showUpload"
      width="550px"
      title="批量设置个人中心背景图"
      :visible="showUpload"
      @close="() => {
       showUpload = false
      }">
      <el-form v-model="uploadUrl" label-width="100px">
        <el-form-item label="上传图片:" :required="true">
          <el-upload
            v-loading="loading"
            ref="upload"
            class="avatar-uploader"
            :action="action"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="el-upload__tip">提示：尺寸小于等于750*360px，分辨率72dpi，大小控制在500kb以内，格式为jpg、png</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="swal-footer">
        <div class="swal-button-container">
          <button
            :disabled="!uploadUrl"
            class="swal-button swal-button--confirm btn btn-primary"
            @click="submitUpload"
          >确定
          </button>
        </div>
        <div class="swal-button-container">
          <div
            class="swal-button swal-button--cancel btn btn-default"
            @click="showUpload = false"
          >取消
          </div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Qs from 'qs'
import axios from 'axios'
import http from '../../common/http'
import {postFormData, postJSON} from '../../utils/request'

import brandAndSeries from '../../common/mixins/brandAndSeries'
import dayjs from 'dayjs'

export default {
  name: 'StoreList',
  mixins: [brandAndSeries],
  data () {
    var checkName = (rule, value, callback) => {
      setTimeout(() => {
        if (value.length > 32) {
          callback(new Error('门店名称必须小于33位'))
        } else {
          callback()
        }
      }, 1000)
    }
    var checktell = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入联系方式'))
      }
      setTimeout(() => {
        let reg = /^1[3456789]\d{9}$/
        if (value && !reg.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      }, 1000)
    }
    var checktel = (rule, value, callback) => {
      setTimeout(() => {
        let reg = /^1[3456789]\d{9}$/
        if (value && !reg.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      }, 1000)
    }
    var checkbankCard = (rule, value, callback) => {
      setTimeout(() => {
        let reg = /^\d{8,}$/
        if (value && !reg.test(value)) {
          callback(new Error('请输入正确的银行卡号'))
        } else {
          callback()
        }
      }, 1000)
    }
    var checkbankidCard = (rule, value, callback) => {
      setTimeout(() => {
        let reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
        if (value && !reg.test(value)) {
          callback(new Error('请输入正确的身份证号'))
        } else {
          callback()
        }
      }, 1000)
    }
    var checkCreditCode = (rule, value, callback) => {
      setTimeout(() => {
        let reg = /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/
        if (value && !reg.test(value)) {
          callback(new Error('请输入正确的统一社会信用代码'))
        } else {
          callback()
        }
      }, 1000)
    }
    var checkTelephones = (rule, value, callback) => {
      setTimeout(() => {
        this.telephones = this.ruleForm.telephones ? this.ruleForm.telephones.replace(/[\uff0c]/g, ',').split(',') : []
        let reg = /^1\d{10}$/
        let isOk = false
        this.telephones.map(item => {
          if (item && !reg.test(item)) {
            isOk = true
          }
        })
        if (isOk) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      }, 1000)
    }
    return {
      pageSize: 10,
      totalCount: 0,
      pageindex: 1,
      outerVisible: false,
      outerVisibles: false,
      batchGoodsVisible: false,
      batchGoodsList: [],
      DialogTitle: '新增',
      EditDialog: 1,
      OuterWidth: '500px',
      CurrentSelection: [],
      CloseShow: false,
      disabled: false,
      options: [],
      shopFuzzy: '',
      shopTel: '',
      addRess: '',
      recomFuzzy: '',
      recom_id: '',
      transferList: [],
      courierMarkList: [{
        label: '自提',
        value: 1
      },
      {
        label: '快递',
        value: 2
      },
      {
        label: '自提/快递',
        value: 3
      }
      ],
      bankList: [],
      checkValid: true,
      ruleForm: {},
      telephones: [],
      showMessage: false,
      rules: {
        firstAreaId: [
          { required: true, message: '请选择大区', trigger: 'change' }
        ],
        secondAreaId: [
          { required: true, message: '请选择分区', trigger: 'change' }
        ],
        thirdAreaId: [
          { required: true, message: '请选择区域', trigger: 'change' }
        ],
        shopCode: [
          {required: true, message: '请输入门店编号', trigger: 'blur'}
        ],
        shopName: [
          {required: true, message: '请输入门店名称', trigger: 'blur'},
          {validator: checkName, trigger: 'blur'}
        ],
        transferCode: [
          {required: true, message: '请选择客户端分润方式', trigger: 'change'}
        ],
        managerTransferCode: [
          {required: true, message: '请选择店长端分润方式', trigger: 'change'}
        ],
        courierMark: [
          {required: true, message: '请选择取货方式', trigger: 'change'}
        ],
        bossName: [
          {required: true, message: '请输入老板姓名', trigger: 'blur'}
        ],
        shopTel: [
          {required: true, validator: checktell, trigger: 'blur'}
        ],
        province: [
          {required: true, message: '请选择所在省', trigger: 'change'}
        ],
        city: [
          {required: true, message: '请选择所在市', trigger: 'change'}
        ],
        district: [
          {required: true, message: '请选择所在区', trigger: 'change'}
        ],
        address: [
          {required: true, message: '请输入详细地址', trigger: 'blur'}
        ],
        telephones: [
          {validator: checkTelephones, trigger: 'blur'}
        ],

        trueName: [
          {required: true, message: '请输入账户名称', trigger: 'blur'}
        ],
        bankName: [
          {required: true, message: '请选择开户银行', trigger: 'change'}
        ],
        bankBranchName: [
          {required: true, message: '请输入开户支行', trigger: 'blur'}
        ],
        bankProvince: [
          {required: true, message: '请选择银行所属省', trigger: 'change'}
        ],
        bankCity: [
          {required: true, message: '请选择银行所属城市', trigger: 'change'}
        ],
        bankType: [
          {required: true, message: '请选择账户类型', trigger: 'change'}
        ],
        bankCard: [
          {required: true, message: '请输入银行卡号', trigger: 'blur'},
          {validator: checkbankCard, trigger: 'blur'}
        ],
        idCard: [
          {required: true, message: '请输入持卡人身份证号', trigger: 'blur'},
          {validator: checkbankidCard, trigger: 'blur'}
        ],
        creditCode: [
          {required: true, message: "请输入统一社会信用代码", trigger: "blur"},
          {validator: checkCreditCode, trigger: "blur"}
        ],
        bankTel: [
          {required: true, message: '请输入持卡人手机号', trigger: 'blur'},
          {validator: checktel, trigger: 'blur'}
        ]
      },
      ProvincesList: [],
      cityList: [],
      ProvincesLists: [],
      cityLists: [],
      countryList: [],
      bankoptions: [
        {
          label: '公司户',
          value: 'C'
        },
        {
          label: '个人户',
          value: 'P'
        }
      ],
      UserManagementList: [],
      imgurl: '',
      companyId: '',
      recomName: '',
      selection: [],
      selectionGoods: [],
      // 0：上架  1: 下架
      batchMode: 0,
      fuzzy: '',

      isRecomRole: true,
      showTips: false,
      tipsList: [],
      showUpload: false,
      loading: false,
      imageUrl: '',
      uploadUrl: '',
      action: '',
      shopName: '',
      imgLoading: false,
      signLoading: false,
      form: {},
      value1: [],
      lesseeList: [],
      departmentList: [],
      regionalList: [],
      partitionList: [],
      districtList: [],
      recomRegionalList: [],
      recomPartitionList: [],
      recomDistrictList: [],
      statusList: [
        {
          label: "全部",
          value: ''
        },
        {
          label: "启用中",
          value: 1
        },
        {
          label: "已禁用",
          value: 0
        }
      ],
      status: '',
      statusName: '',
      hiddenbutton: '',
      personList: []
    }
  },

  created () {
    axios.post(`/user/roles/selectLoginRoles`)
      .then(res => {
        const roleList = (res.data || {}).data || []

        for (let role of roleList) {
          if (role.roleId === 5101) {
            this.isRecomRole = true
            return
          }
        }

        this.isRecomRole = false
      })
    axios.get(`/distribution/B2cFenrunTransferController/queryFrTransfer`, {
      params: {
        ...this.searchForm
      }
    }).then(res => {
      const resData = res.data || {}
      this.transferList = resData.data || []
    })
  },
  mounted: function () {
    if (this.$route.query.recomId) {
      this.recom_id = this.$route.query.recomId
      this.recomName = this.$route.query.recomName
    }
    if (this.$route.query.companyId) {
      this.companyId = this.$route.query.companyId
    }
    if (this.$route.params && this.$route.params.searchContent) {
      this.recomFuzzy = this.$route.params.searchContent.recomFuzzy
      this.shopFuzzy = this.$route.params.searchContent.shopFuzzy
    }
    this.initdata()
    this.initProvinces()
    this.initBank()
    this.getLesseeList()
    this.initDatabutton()
    this.getPersonPageList()
  },
  watch: {
    pageNo: {
      handler (newName, oldName) {
        if (this.$route.params && this.$route.params.pageNo) {
          this.pageNo = this.$route.params.pageNo
        }
      },
      immediate: true
    },
    pagesize: {
      handler (newName, oldName) {
        if (this.$route.params && this.$route.params.pagesize) {
          this.pageSize = this.$route.params.pagesize
        }
      },
      immediate: true
    }
  },
  computed: {
    pageNo: {
      set (val) {
        if (val) {
          this.pageindex = val
        }
      },
      get () {
        // console.log('我被调用了') //msg1获取值时触发

      }
    },
    pagesize: {
      set (val) {
        if (val) {
          this.pageSize = val
        }
      },
      get () {
        // console.log('我被调用了') //msg1获取值时触发

      }
    }
  },
  methods: {
    dayjs,
    //显示 隐藏   按钮  数据
    initDatabutton() {
      let that = this;
      const options = {
        //  获取当前登录人角色
        url: "/distribution/B2cOrderInfoController/parsingUserTob",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // 请求参数
        data: Qs.stringify({})
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          that.hiddenbutton = String(response.data.data.roleId);
        } else {
          that.$notify({
            title: "失败",
            message: response.data.message,
            type: "error"
          });
        }
      });
    },
    getLesseeList () {
      let that = this
      axios.get('/distribution/lessee/getLesseeList').then(response => {
        if (response.data.code === 200) {
          that.lesseeList = response.data.data
        } else {
          http.handleEorrorCode(response, that)
        }
      })
        .catch(error => {
          http.handleHttpError(error, that)
        })
    },
    getDeptList () {
      let that = this
      axios.get('/distribution/dept/getDeptList', {
        params: {
          lesseeId: that.form.lesseeId
        }
      }).then(response => {
        if (response.data.code === 200) {
          that.departmentList = response.data.data
        } else {
          http.handleEorrorCode(response, that)
        }
      })
        .catch(error => {
          http.handleHttpError(error, that)
        })
    },
    getAreaPageList () {
      let that = this
      axios.get('/distribution/area/getAreaList', {
        params: {
          lesseeId: that.form.lesseeId,
          deptId: that.form.deptId,
          areaType: that.form.secondAreaId ? 3 : that.form.firstAreaId ? 2 : 1,
          parentId: that.form.secondAreaId ? that.form.secondAreaId : that.form.firstAreaId ? that.form.firstAreaId : 0
        }
      }).then(response => {
        if (response.data.code === 200) {
          if (that.form.secondAreaId) {
            that.districtList = response.data.data
          } else if (that.form.firstAreaId) {
            that.partitionList = response.data.data
          } else {
            that.regionalList = response.data.data
          }
        } else {
          http.handleEorrorCode(response, that)
        }
      })
        .catch(error => {
          http.handleHttpError(error, that)
        })
    },
    handleUploadBg () {
      let url = process.env.UPLOAD_URL || 'https://test.germanygou.com:8443/api'
      this.action = `${url}/common/public/commonFile/commonFileUpload`
      this.showUpload = true
      this.imageUrl = ''
      this.uploadUrl = ''
    },
    handleAvatarSuccess (res, file) {
      this.imageUrl = `${process.env.FILE_URL}` + file.response.data
      this.uploadUrl = file.response.data
      this.loading = false
    },
    submitUpload () {
      let that = this
      const options = {
        url: '/distribution/distribution/updateBackgroundPhoto',
        method: 'put',
        data: {
          shopIdList: that.selection.map(item => item.shopId).join(','),
          backgroundPhoto: that.uploadUrl
        }
      }
      axios(options)
        .then(function (response) {
          if (response.data.code === 200) {
            that.$notify({
              title: '成功',
              message: response.data.message,
              type: 'success'
            })
            that.showUpload = false
          } else {
            http.handleEorrorCode(response, that)
          }
        })
        .catch(error => {
          http.handleHttpError(error, that)
        })
    },
    beforeAvatarUpload (file) {
      this.loading = true
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 < 500
      if (!isJPG) {
        this.loading = false
        this.$message.error('上传图片只能是 jpg或png 格式!')
        return isJPG
      }
      if (!isLt2M) {
        this.loading = false
        this.$message.error('上传图片大小不能超过 500kb!')
        return isLt2M
      }
      const isSize = new Promise(function (resolve, reject) {
        let width = 750
        let height = 360
        let _URL = window.URL || window.webkitURL
        let img = new Image()
        img.onload = function () {
          let valid = img.width <= width && img.height <= height
          valid ? resolve() : reject()
        }
        img.src = _URL.createObjectURL(file)
      }).then(() => {
        return file
      }, () => {
        this.$message.error('上传的图片尺寸小于等于750*360!')
        this.loading = false
        return Promise.reject()
      })
      return isJPG && isLt2M && isSize
    },
    courierMarkChange (val) {
      if (val === 1) {
        this.checkValid = true
      } else {
        this.checkValid = false
      }
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {
        })
    },
    initBank () {
      let that = this
      const options = {
        url: 'distribution/B2cBankInfoController/getBankInfo',
        method: 'post',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        data: Qs.stringify({})
      }
      axios(options)
        .then(function (response) {
          if (response.data.code === 200) {
            that.bankList = response.data.data
          } else {
            http.handleEorrorCode(response, that)
          }
        })
        .catch(error => {
          http.handleHttpError(error, that)
        })
    },

    async handleLoadBatchShopGoods (mode) {
      if (mode !== undefined) {
        this.batchMode = mode
      }

      const res = await postFormData(
        `/distribution/B2cSkuOnlineController/getBatchShopGoodsInfoList`,
        {
          recomId: this.recom_id,
          companyId: this.companyId,
          brandId: this.brandId,
          seriesId: this.seriesId,
          fuzzy: this.fuzzy
        }
      ).catch(res => http.handleHttpError(res, this))

      const code = res && res.data && res.data.code
      const data = res && res.data && res.data.data

      if (code === 200) {
        this.batchGoodsList = data || []
        this.batchGoodsVisible = true
        return
      }

      res && http.handleEorrorCode(res, this)
    },

    async handleBatchGoods () {
      let res = null

      const postData = {
        recomId: this.recom_id,
        companyId: this.companyId,
        shopIdList: this.selection.map(item => item.shopId),
        shopGoodsInfoList: this.selectionGoods
          .filter(item => item)
          .map(({goodsId, id, packageRates, groupId}) => ({
            goodsId,
            id,
            packageRates,
            groupId
          }))
      }
      this.tipsList = []

      if (this.batchMode === 0) {
        res = await postJSON(
          `distribution/B2cSkuOnlineController/upShopShelfBatch`,
          postData
        ).catch(res => {
          // console.log(res)
        })
      }

      if (this.batchMode === 1) {
        res = await postJSON(
          `/distribution/B2cSkuOnlineController/shopBatchLowerShelfSkuGoods`,
          postData
        )
      }
      if (res && res.data && res.data.data && res.data.data.length > 0) {
        this.tipsList = res.data.data
        this.showTips = true
      } else {
        this.$notify({
          title: '成功',
          message: res.data.message,
          type: 'success'
        })
      }
      this.batchMode === 1 && this.handleLoadBatchShopGoods()

      // http.handleEorrorCode(res, this)
    },
    flitterData (arr) {
      let spanOneArr = []
      let concatOne = 0
      arr.forEach((item, index) => {
        if (index === 0) {
          spanOneArr.push(1)
        } else {
          // name 修改
          if (item.shopId === arr[index - 1].shopId) { // 第一列需合并相同内容的判断条件
            spanOneArr[concatOne] += 1
            spanOneArr.push(0)
          } else {
            spanOneArr.push(1)
            concatOne = index
          }
        }
      })
      return {
        one: spanOneArr
      }
    },
    objectSpanMethod ({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 0) {
        // this.tableData  修改
        const _row = (this.flitterData(this.tipsList).one)[rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },
    initProvinces () {
      let that = this
      const options = {
        url: 'distribution/B2cRegionalLinkageController/queryAllProvince',
        method: 'post',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        data: Qs.stringify({})
      }
      axios(options)
        .then(function (response) {
          if (response.data.code === 200) {
            that.ProvincesList = response.data.data
            that.ProvincesLists = response.data.data
          } else {
            http.handleEorrorCode(response, that)
          }
        })
        .catch(error => {
          http.handleHttpError(error, that)
        })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.pageindex = 1
      this.initdata()
    },
    Goback (val) {
      this.$router.push({
        name: 'DistributorList',
        params: {pageNo: this.pageNo, pagesize: this.pageSize, searchContent: this.searchContent}
      })
    },
    handleCurrentChange (val) {
      this.pageindex = val
      this.initdata()
    },
    SettingClick (row) {
      if (this.recom_id === '') {
        this.$router.push({path: '/selesclerklist'})
      } else {
        this.$router.push({path: '/selesclerklist', query: {recomId: this.recom_id, companyId: this.companyId, recomName: this.$route.query.recomName}})
      }
      localStorage.setItem('goodlist', JSON.stringify({
        shopId: row.shopId,
        pageNo: this.pageindex,
        pageSize: this.pageSize,
        recomId: row.recomId
      }))
    },
    // 门店设置
    SettingShop (row) {
      let href = this.$router.resolve({
        path: '/o2osettingmenu',
        name: 'O2OSettingMenu',
        query: {recomId: row.recomId, shopId: row.shopId}
      })
      window.open(href.href, '_blank')
    },
    DetailClick (row) {
      if (this.recom_id === '') {
        this.$router.push({path: '/storedetail'})
      } else {
        this.$router.push({path: '/storedetail', query: {recomId: this.recom_id, companyId: this.companyId}})
      }
      let searchContent = {}
      searchContent.recomFuzzy = this.recomFuzzy
      searchContent.shopFuzzy = this.shopFuzzy
      localStorage.setItem('goodlist', JSON.stringify({
        shopId: row.shopId,
        pageNo: this.pageindex,
        pageSize: this.pageSize,
        searchContent: searchContent
      }))
    },
    bankChange (val) {
      let that = this
      that.cityLists = []
      that.$set(that.ruleForm, 'bankCity', undefined)
      if (val) {
        const options = {
          url: 'distribution/B2cRegionalLinkageController/queryCity',
          method: 'post',
          headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          data: Qs.stringify({
            provinceName: val
          })
        }
        axios(options)
          .then(function (response) {
            if (response.data.code === 200) {
              that.cityLists = response.data.data
            } else {
              http.handleEorrorCode(response, that)
            }
          })
          .catch(error => {
            http.handleHttpError(error, that)
          })
      }
    },
    queryCity (val) {
      let that = this
      const options = {
        url: 'distribution/B2cRegionalLinkageController/queryCity',
        method: 'post',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        data: Qs.stringify({
          provinceName: val
        })
      }
      axios(options)
        .then(function (response) {
          if (response.data.code === 200) {
            that.cityList = response.data.data
          } else {
            http.handleEorrorCode(response, that)
          }
        })
        .catch(error => {
          http.handleHttpError(error, that)
        })
    },
    queryBankCity (val) {
      let that = this
      const options = {
        url: 'distribution/B2cRegionalLinkageController/queryCity',
        method: 'post',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        data: Qs.stringify({
          provinceName: val
        })
      }
      axios(options)
        .then(function (response) {
          if (response.data.code === 200) {
            that.cityLists = response.data.data
          } else {
            http.handleEorrorCode(response, that)
          }
        })
        .catch(error => {
          http.handleHttpError(error, that)
        })
    },
    queryCountry (val) {
      let that = this
      const options = {
        url: 'distribution/B2cRegionalLinkageController/queryCounty',
        method: 'post',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        data: Qs.stringify({
          cityName: val
        })
      }
      axios(options)
        .then(function (response) {
          if (response.data.code === 200) {
            that.countryList = response.data.data
          } else {
            http.handleEorrorCode(response, that)
          }
        })
        .catch(error => {
          http.handleHttpError(error, that)
        })
    },
    provinceChange (val) {
      let that = this
      if (val === '') {
        that.ruleForm.city = ''
        that.cityList = []
        that.ruleForm.district = ''
        that.countryList = []
      } else {
        const options = {
          url: 'distribution/B2cRegionalLinkageController/queryCity',
          method: 'post',
          headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          data: Qs.stringify({
            provinceName: val
          })
        }
        axios(options)
          .then(function (response) {
            if (response.data.code === 200) {
              that.cityList = response.data.data
              if (that.ruleForm.city) {
                that.ruleForm.city = ''
              }
              if (that.ruleForm.district) {
                that.ruleForm.district = ''
              }
            } else {
              http.handleEorrorCode(response, that)
            }
          })
          .catch(error => {
            http.handleHttpError(error, that)
          })
      }
    },
    CityChange (val) {
      let that = this
      if (val === '') {
        that.countryList = []
        that.ruleForm.district = ''
      } else {
        const options = {
          url: 'distribution/B2cRegionalLinkageController/queryCounty',
          method: 'post',
          headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          data: Qs.stringify({
            cityName: val
          })
        }
        axios(options)
          .then(function (response) {
            if (response.data.code === 200) {
              that.countryList = response.data.data
              if (that.ruleForm.district) {
                that.ruleForm.district = ''
              }
            } else {
              http.handleEorrorCode(response, that)
            }
          })
          .catch(error => {
            http.handleHttpError(error, that)
          })
      }
    },
    DeleteClick (item,statusName) {
      this.outerVisible = true
      this.EditDialog = 2
      this.OuterWidth = '500px'
      this.CurrentSelection = item
      this.statusName = statusName
    },
    AddClick () {
      this.ruleForm = {}
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].resetFields()
      }
      this.checkValid = false
      this.outerVisible = true
      this.DialogTitle = '新增'
      this.OuterWidth = '800px'
      this.EditDialog = 1
      this.recomRegionalList = []
      this.recomPartitionList = []
      this.recomDistrictList = []
      this.queryB2cRecomAreaRef(this.recom_id)
    },
    EditClick (item) {
      this.ruleForm = {}
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].resetFields()
      }
      if (item.transferCode === 1) {
        this.checkValid = true
      } else {
        this.checkValid = false
      }
      this.outerVisible = true
      this.DialogTitle = '编辑'
      this.OuterWidth = '800px'
      this.EditDialog = 1
      this.recomRegionalList = []
      this.recomPartitionList = []
      this.recomDistrictList = []
      this.CurrentSelection = item
      this.EditDetail(item.shopId, item.recomId)

    },
    queryB2cRecomAreaRef (val) {
      let that = this
      axios.get('/distribution/b2cRecomAreaRef/queryB2cRecomAreaRef', {
        params: {
          recomId: val
        }
      }).then(async res => {
        if (res.data.code === 200) {
          that.$set(that.ruleForm, 'lesseeId', res.data.data.recom.lesseeId)
          that.$set(that.ruleForm, 'deptId', res.data.data.recom.deptId)
          if (res.data.data.areaList.length === 1) {
            that.$set(that.ruleForm, 'firstAreaId', res.data.data.areaList[0].areaId)
            await that.getRecomAreaPageList()
          }
          that.recomRegionalList = res.data.data.areaList
        }
      })
    },
    getRecomAreaPageList () {
      let that = this
      axios.get('/distribution/area/getAreaList', {
        params: {
          lesseeId: that.ruleForm.lesseeId,
          deptId: that.ruleForm.deptId,
          areaType: that.ruleForm.secondAreaId ? 3 : 2,
          parentId: that.ruleForm.secondAreaId ? that.ruleForm.secondAreaId : that.ruleForm.firstAreaId
        }
      }).then(response => {
        if (response.data.code === 200) {
          if (that.ruleForm.secondAreaId) {
            that.recomDistrictList = response.data.data
          } else if (that.ruleForm.firstAreaId) {
            that.recomPartitionList = response.data.data
          }
        } else {
          http.handleEorrorCode(response, that)
        }
      })
        .catch(error => {
          http.handleHttpError(error, that)
        })
    },
    EditDetail (id, recomId) {
      let that = this
      that.telephones = []
      const options = {
        url: 'distribution/distribution/queryB2cO2oShopById',
        method: 'post',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        data: Qs.stringify({
          shopId: id
        })
      }
      axios(options).then(function (response) {
        if (response.data.code === 200) {
          delete response.data.data.bankProvince
          delete response.data.data.bankCity
          delete response.data.data.bankName
          let Object = {
            ...JSON.parse(response.data.data.accountData),
            ...response.data.data,
            transferCode: String(response.data.data.transferCode)
          }
          that.ruleForm = Object
          if (that.ruleForm.province !== null && that.ruleForm.city === null) {
            that.queryCity(response.data.data.province)
          }
          if (that.ruleForm.province !== null && that.ruleForm.city !== null && that.ruleForm.district !== null) {
            that.queryCity(response.data.data.province)
            that.queryCountry(response.data.data.city)
          }
          if (that.ruleForm.bankProvince) {
            that.queryBankCity(that.ruleForm.bankProvince)
          }
          if (that.ruleForm.lesseePersonCode) {
            that.getPersonPageList(that.ruleForm.lesseePersonCode)
          }
          that.ruleForm.telephones = response.data.data.telephones
          that.queryB2cRecomAreaRef(recomId)

          that.ruleForm.firstAreaId && axios.get('/distribution/area/getAreaList', {
            params: {
              lesseeId: that.ruleForm.lesseeId,
              deptId: that.ruleForm.deptId,
              areaType: 2,
              parentId: that.ruleForm.firstAreaId
            }
          }).then(response => {
            if (response.data.code === 200) {
              that.recomPartitionList = response.data.data
              that.ruleForm.secondAreaId && that.getRecomAreaPageList()
            } else {
              http.handleEorrorCode(response, that)
            }
          })
            .catch(error => {
              http.handleHttpError(error, that)
            })
        } else {
          http.handleEorrorCode(response, that)
        }
      })
    },
    SearchClick () {
      this.pageindex = 1
      this.initdata()
    },
    MakeSureEdit (formName) {
      let that = this
      if (this.DialogTitle === '新增') {
        that.$refs[formName].validate(valid => {
          if (valid) {
            this.disabled = true
            let bossName = ''
            let trueName = ''
            if (this.ruleForm.bossName) {
              bossName = this.ruleForm.bossName.replace(/\s+/g, '')
            } else {
              bossName = this.ruleForm.bossName
            }
            if (this.ruleForm.trueName) {
              trueName = this.ruleForm.trueName.replace(/\s+/g, '')
            } else {
              trueName = this.ruleForm.trueName
            }
            const currentTransferInfo = this.transferList
              .find(item => item && item.transferCode === this.ruleForm.transferCode) ||
              {}
            const managerTransferInfo = this.transferList
              .find(item => item && item.transferCode === this.ruleForm.managerTransferCode) ||
              {}
            const options = {
              url: 'distribution/distribution/addB2cO2oShop',
              method: 'post',
              headers: {'Content-Type': 'application/json'},
              data: {
                lesseeId: that.ruleForm.lesseeId,
                deptId: that.ruleForm.deptId,
                firstAreaId: that.ruleForm.firstAreaId,
                secondAreaId: that.ruleForm.secondAreaId,
                thirdAreaId: that.ruleForm.thirdAreaId,
                thirdShopCode: that.ruleForm.thirdShopCode,
                companyId: that.companyId,
                recomId: that.recom_id,
                shopCode: that.ruleForm.shopCode,
                shopName: that.ruleForm.shopName.replace(/\s+/g, ''),
                transferCode: that.ruleForm.transferCode,
                managerTransferCode: that.ruleForm.managerTransferCode,
                managerTransferWay: managerTransferInfo.transferId,
                transferWay: currentTransferInfo.transferId,
                bossName: bossName,
                shopTel: that.ruleForm.shopTel,
                province: that.ruleForm.province,
                city: that.ruleForm.city,
                district: that.ruleForm.district,
                address: that.ruleForm.address,
                courierMark: that.ruleForm.courierMark,
                noted: that.ruleForm.noted,
                telephones: this.ruleForm.telephones ? this.ruleForm.telephones.replace(/[\uff0c]/g, ',') : '',
                lesseePersonCode: that.ruleForm.lesseePersonCode,
                payAccountInfoList: [{
                  bankName: that.ruleForm.bankName,
                  trueName: trueName,
                  bankCard: that.ruleForm.bankCard,
                  bankBranchName: that.ruleForm.bankBranchName,
                  bankProvince: that.ruleForm.bankProvince,
                  bankCity: that.ruleForm.bankCity,
                  bankType: that.ruleForm.bankType,
                  idCard: that.ruleForm.bankType === 'P' ? that.ruleForm.idCard : undefined,
                  creditCode: that.ruleForm.bankType === 'C' ? that.ruleForm.creditCode : undefined,
                  bankTel: that.ruleForm.bankTel
                }]
              }
            }
            axios(options).then(function (response) {
              that.disabled = false
              if (response.data.code === 200) {
                that.outerVisible = false
                that.initdata()
                that.$notify({
                  title: '成功',
                  message: response.data.message,
                  type: 'success'
                })
              } else {
                that.outerVisible = true
                http.handleEorrorCode(response, that)
              }
            })
              .catch(function (error) {
                that.disabled = false
                that.outerVisible = false
                http.handleHttpError(error, that)
              })
          } else {
            this.outerVisible = true
          }
        })
      } else if (this.DialogTitle === '编辑') {
        that.$refs[formName].validate(valid => {
          if (valid) {
            this.disabled = true
            let bossName = ''
            let trueName = ''
            if (this.ruleForm.bossName) {
              bossName = this.ruleForm.bossName.replace(/\s+/g, '')
            } else {
              bossName = this.ruleForm.bossName
            }
            if (this.ruleForm.trueName) {
              trueName = this.ruleForm.trueName.replace(/\s+/g, '')
            } else {
              trueName = this.ruleForm.trueName
            }

            const currentTransferInfo = this.transferList
              .find(item => item && item.transferCode === this.ruleForm.transferCode) ||
              {}
            const managerTransferInfo = this.transferList
              .find(item => item && item.transferCode === this.ruleForm.managerTransferCode) ||
              {}
            const options = {
              url: 'distribution/distribution/updateB2cO2oShop',
              method: 'post',
              headers: {'Content-Type': 'application/json'},
              data: {
                lesseeId: that.ruleForm.lesseeId,
                deptId: that.ruleForm.deptId,
                firstAreaId: that.ruleForm.firstAreaId,
                secondAreaId: that.ruleForm.secondAreaId,
                thirdAreaId: that.ruleForm.thirdAreaId,
                thirdShopCode: that.ruleForm.thirdShopCode,
                companyId: that.companyId,
                shopId: that.CurrentSelection.shopId,
                recomId: that.CurrentSelection.recomId,
                shopCode: that.ruleForm.shopCode,
                shopName: that.ruleForm.shopName.replace(/\s+/g, ''),
                transferCode: that.ruleForm.transferCode,
                managerTransferCode: that.ruleForm.managerTransferCode,
                managerTransferWay: managerTransferInfo.transferId,
                transferWay: currentTransferInfo.transferId,
                bossName: bossName,
                shopTel: that.ruleForm.shopTel,
                province: that.ruleForm.province,
                city: that.ruleForm.city,
                district: that.ruleForm.district,
                address: that.ruleForm.address,
                courierMark: that.ruleForm.courierMark,
                noted: that.ruleForm.noted,
                telephones: this.ruleForm.telephones ? this.ruleForm.telephones.replace(/[\uff0c]/g, ',') : '',
                lesseePersonCode: that.ruleForm.lesseePersonCode,
                payAccountInfoList: [{
                  bankName: that.ruleForm.bankName,
                  trueName: trueName,
                  bankCard: that.ruleForm.bankCard,
                  bankBranchName: that.ruleForm.bankBranchName,
                  bankProvince: that.ruleForm.bankProvince,
                  bankCity: that.ruleForm.bankCity,
                  bankType: that.ruleForm.bankType,
                  idCard: that.ruleForm.bankType === 'P' ? that.ruleForm.idCard : undefined,
                  creditCode: that.ruleForm.bankType === 'C' ? that.ruleForm.creditCode : undefined,
                  bankTel: that.ruleForm.bankTel
                }]
              }
            }
            axios(options).then(function (response) {
              that.disabled = false
              if (response.data.code === 200) {
                that.outerVisible = false
                that.initdata()
                that.$notify({
                  title: '成功',
                  message: response.data.message,
                  type: 'success'
                })
              } else {
                that.outerVisible = true
                http.handleEorrorCode(response, that)
              }
            })
              .catch(function (error) {
                that.disabled = false
                that.outerVisible = false
                http.handleHttpError(error, that)
              })
          } else {
            this.outerVisible = true
          }
        })
      }
    },
    MakeSure () {
      let that = this
      that.disabled = true
      const options = {
        url: '/distribution/distribution/updateB2cO2oShopStatus',
        method: 'post',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        data: Qs.stringify({
          shopId: that.CurrentSelection.shopId,
          recomId: that.CurrentSelection.recomId,
          shopCode: that.CurrentSelection.shopCode,
          status: that.statusName === '禁用' ? 0 : 1
        })
      }
      axios(options).then(function (response) {
        that.disabled = false
        that.outerVisible = false
        that.initdata()
        if (response.data.code === 200) {
          that.$notify({
            title: '成功',
            message: response.data.message,
            type: 'success'
          })
        } else {
          http.handleEorrorCode(response, that)
        }
      }).catch(function (error) {
        that.disabled = false
        that.outerVisible = false
        http.handleHttpError(error, that)
      })
    },
    initdata () {
      let that = this
      const options = {
        url: 'distribution/distribution/queryB2cO2oShop',
        method: 'post',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        data: Qs.stringify({
          recomFuzzy: that.recomFuzzy,
          shopFuzzy: that.shopFuzzy,
          shopTel: that.shopTel,
          addRess: that.addRess,
          recomId: that.recom_id,
          lesseeId: that.form.lesseeId,
          deptId: that.form.deptId,
          firstAreaId: that.form.firstAreaId,
          secondAreaId: that.form.secondAreaId,
          thirdAreaId: that.form.thirdAreaId,
          startTime: that.value1 && that.value1.length > 0 ? dayjs(that.value1[0]).format('YYYY-MM-DD HH:mm:ss') : undefined,
          endTime: that.value1 && that.value1.length > 0 ? dayjs(that.value1[1]).format('YYYY-MM-DD HH:mm:ss') : undefined,
          status: that.status,
          size: that.pageSize,
          current: that.pageindex
        })
      }
      axios(options).then(function (response) {
        if (response.data.code === 200) {
          that.totalCount = response.data.data.totalCount
          for (var i in response.data.data.data) {
            response.data.data.data[i].ordernumber =
              Number((that.pageindex - 1) * that.pageSize) + Number(i) + 1
            for (var j in response.data.data.data[i].shoperList) {
              if (response.data.data.data[i].shoperList[j].shoperRole === 3) {
                response.data.data.data[i].bossName = response.data.data.data[i].shoperList[j].shooperName
                response.data.data.data[i].shoperTel = response.data.data.data[i].shoperList[j].shooperTel
                response.data.data.data[i].shoperCount = response.data.data.data[i].shoperList.length
              }
            }
          }
          that.UserManagementList = response.data.data.data
        } else {
          http.handleEorrorCode(response, that)
        }
      }).catch(function (error) {
        http.handleHttpError(error, that)
      })
    },
    CodeClick (row) {
      this.CurrentSelection = row
      this.outerVisibles = true
      this.shopName = row.shopName
      this.imgLoading = true
      let that = this
      const options = {
        url: 'distribution/distribution/getShopUrl',
        method: 'post',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        data: Qs.stringify({
          shopId: that.CurrentSelection.shopId,
          recomId: that.CurrentSelection.recomId
        })
      }
      axios(options)
        .then(function (response) {
          if (response.data.code === 200) {
            that.generateQrCode(response.data.data.domainUrl, that.CurrentSelection.shopName)
          } else {
            that.outerVisibles = false
            http.handleEorrorCode(response, that)
          }
        })
        .catch(function (error) {
          http.handleHttpError(error, that)
        })
    },
    generateQrCode (content, name) {
      let that = this
      let url = process.env.UPLOAD_URL
      const options = {
        url: url + '/common/image/generateQrCode',
        method: 'post',
        headers: {'Content-Type': 'application/json'},
        data: {
          content: content,
          name: name
        },
        responseType: 'blob'
      }
      axios(options)
        .then(function (response) {
          that.imgurl = window.URL.createObjectURL(response.data)
          that.imgLoading = false
        })
        .catch(error => {
          http.handleHttpError(error, that)
          that.imgLoading = false
        })
    },
    downLoadQrCode (imgUrl, shopName) {
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = imgUrl
      link.setAttribute('download', shopName + '二维码' + '.jpg')
      document.body.appendChild(link)
      link.click()
    },
    downLoadShopSign () {
      let that = this
      that.signLoading = true
      const options = {
        url: 'distribution/distribution/getShopUrl',
        method: 'post',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        data: Qs.stringify({
          shopId: that.CurrentSelection.shopId,
          recomId: that.CurrentSelection.recomId
        })
      }
      axios(options)
        .then(function (response) {
          if (response.data.code === 200) {
            that.generateShopDisPlayImage(response.data.data.domainUrl, that.CurrentSelection.shopName)
          } else {
            http.handleEorrorCode(response, that)
          }
        })
        .catch(function (error) {
          http.handleHttpError(error, that)
        })
    },
    generateShopDisPlayImage (content, name) {
      let that = this
      let url = process.env.UPLOAD_URL
      const options = {
        url: url + '/common/image/generateShopDisPlayImage',
        method: 'post',
        headers: {'Content-Type': 'application/json'},
        data: {
          content: content,
          name: name
        },
        responseType: 'blob'
      }
      axios(options)
        .then(function (response) {
          let url = window.URL.createObjectURL(response.data)
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', name + '展示牌' + '.jpg')
          document.body.appendChild(link)
          link.click()
          that.signLoading = false
        })
        .catch(error => {
          http.handleHttpError(error, that)
          that.signLoading = false
        })
    },
    handleCloseCanvas () {
      this.outerVisibles = false
      this.imgurl = ''
    },
    // 门店列表导出
    ExportClick () {
      let that = this
      const options = {
        url: '/distribution/ExcelController/exportO2oShopInfo',
        method: 'get',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        params: {
          recomFuzzy: that.recomFuzzy,
          shopFuzzy: that.shopFuzzy,
          shopTel: that.shopTel,
          addRess: that.addRess,
          recomId: that.recom_id,
          lesseeId: that.form.lesseeId,
          deptId: that.form.deptId,
          firstAreaId: that.form.firstAreaId,
          secondAreaId: that.form.secondAreaId,
          thirdAreaId: that.form.thirdAreaId,
          status: that.status,
          startTime: that.value1 && that.value1.length > 0 ? dayjs(that.value1[0]).format('YYYY-MM-DD HH:mm:ss') : undefined,
          endTime: that.value1 && that.value1.length > 0 ? dayjs(that.value1[1]).format('YYYY-MM-DD HH:mm:ss') : undefined,
        }
      }
      axios(options)
        .then(function (response) {
          if (response.data.code !== undefined) {
            http.handleEorrorCode(response, that)
          } else {
            that.ExportClickSecond()
          }
        })
        .catch(error => {
          http.handleHttpError(error, that)
        })
    },
    ExportClickSecond () {
      let that = this
      const options = {
        url: '/distribution/ExcelController/exportO2oShopInfo',
        method: 'get',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        params: {
          recomFuzzy: that.recomFuzzy,
          shopFuzzy: that.shopFuzzy,
          shopTel: that.shopTel,
          addRess: that.addRess,
          recomId: that.recom_id,
          lesseeId: that.form.lesseeId,
          deptId: that.form.deptId,
          firstAreaId: that.form.firstAreaId,
          secondAreaId: that.form.secondAreaId,
          thirdAreaId: that.form.thirdAreaId,
          status: that.status,
          startTime: that.value1 && that.value1.length > 0 ? dayjs(that.value1[0]).format('YYYY-MM-DD HH:mm:ss') : undefined,
          endTime: that.value1 && that.value1.length > 0 ? dayjs(that.value1[1]).format('YYYY-MM-DD HH:mm:ss') : undefined,
        },
        responseType: 'blob'
      }
      axios(options)
        .then(function (response) {
          var filename = '门店列表'
          let url = window.URL.createObjectURL(response.data)
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', filename + '.xlsx')
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          http.handleHttpError(error, that)
        })
    },
    getPersonPageList (query) {
      let that = this
      let url = process.env.UPLOAD_URL
      axios.get(url + '/operation/lesseePerson/getPersonPageList', {
        params: {
          paramInfo: query,
          status: 1,
          pageNo: 1,
          pageSize: 5
        }
      }).then(async res => {
        if (res.data.code === 200) {
          that.personList = res.data.data.records
        }
      })
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}

.PaginationStyle {
  float: right;
  margin-top: 8px;
}

.panelTitle {
  padding-left: 15px;
  text-align: left;
}

.ButtonColor {
  color: #fff !important;
}

.ModelPadding {
  margin-top: -20px;
  text-align: left;
}

.LineSpacing {
  margin-top: 16px;
}

.InputWidth {
  width: 202px;
}

.ModelPaddings {
  margin-top: -20px;
  height: 518px;
}

.ButtonSty {
  padding-top: 20px;
  border-top: 1px solid #ddd;
  text-align: right;
}

</style>
<style>
.avatar-uploader .el-upload {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}

.avatar {
  width: 50%;
  border-radius: 6px;
  display: block;
}

.el-upload__tip {
  font-size: 14px;
}

.el-button:focus {
  color: #3a8ee6;
  border-color: #3a8ee6;
  outline: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/StoreManage/StoreList.vue